<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0041_master_user_detail</div>
        <app-header>esma</app-header>
        <div :class="'container ' +pageContainerSize">
          <title-and-slot title="ユーザ（詳細）" >
          </title-and-slot>
          <div class="row" style="margin-bottom:10px;">
          <div class="col-xs-4">
            <button class="btn btn-primary" style="min-width:100px; max-width:100px;float: left;margin-left: 5px;" @click="backToList" >＜　戻る</button>
          </div>
          <div class="col-xs-8">
              <div style="float:right;font-size:12px;text-align: right;color:red;">＊入力必須項目［兼務設定項目は選択時のみ］</div>
            </div>
          </div>
          <form action="" autocomplete="off">
            <div class="col-xs-4" style="">
              <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f" @on_update="dataUpdated" :read="readOnly" :val="values[f.id]"></field-box>
            </div>
            <div class="col-xs-4" style=""  v-if="showColumns2and3()">
              <field-box    v-for="f in formFields.col2_head"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
              <field-box   v-for="f in formFields.col2"  v-bind:key="f.id" v-bind:data="f" @on_update="dataUpdated" :read="readOnly || readOnly2" :val="values[f.id]"></field-box>
            </div>
            <div class="col-xs-4" style=""  v-if="showColumns2and3()">
              <field-box   v-for="f in formFields.col3_head"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
              <field-box   v-for="f in formFields.col3"  v-bind:key="f.id" v-bind:data="f" @on_update="dataUpdated" :read="readOnly || readOnly3" :val="values[f.id]"></field-box>
            </div>
            </form>
            <div class="row" style="margin-bottom:10px;">
              <div>
              <br>


                <!-- Confirmation -->
              <!-- <button v-show ="hideApplyConfirmationBtn == false"  @click="processApprovalApprove()"
              class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;margin-right:45px;background: #92D050;border-color:#92D050;" >確認</button> -->

              <!-- Rejected -->
              <!-- <button v-show ="hideApplyRejectBtn == false"   @click="processApprovalCancel"
              class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;margin-right:0px;background: #FF7C80;border-color:#FF7C80;" >差戻</button> -->

              <!-- Save draft -->
              <button v-show ="isAdminSavingApplication == false"  @click="onSave"
              :disabled="disabledToSave || checkUserPermission(true,permissionMode.EDIT) == false"
              v-if="read_only == false"  class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;margin-right:20px;background: #92D050;border-color:#92D050;"  >登録</button>

              <!-- Cancel -->
              <button v-if="read_only == false" @click="btnCancel"
                class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #A6A6A6;border-color:#A6A6A6;"  >キャンセル</button>

              <button v-if="read_only == false"
                @click="onPreSetDefaultPassword"
                class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #FF7C80;border-color:#FF7C80;"  >パスワード初期化</button>

              <!-- Edit -->
              <button  v-show="hideEditMainBtn == false" @click="onEdit" :disabled="disableEditMainBtn || checkUserPermission(true,permissionMode.EDIT) == false"
              v-if="read_only != false" class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;margin-right:20px;">編集</button>


              <!-- Erase -->
              <button v-show="hideDeleteBtn == false" @click="onDelete" :disabled="disableDeleteBtn || checkUserPermission(true,permissionMode.DELETE) == false"
              v-if="read_only == true" class="btn btn-primary" style="min-width:100px;float: right;margin-left: 5px;background: #FF7C80;border-color:#FF7C80;">削除</button>
              </div>
            </div>
          </div>
        <!-- </div> -->
        <application-confirmation-modal tag="userApplicationConfimationModal" />
        <confirmation-modal tag="notificationAfterSave" @done="afterTheNotificationAfterSave" />
        <confirmation-modal tag="confirmDeviceEmbeddedInformationAddCheck" @done="onDeviceEmbeddedInformationAddCheckConfirm" />
        <confirmation-modal tag="deleteMasterUserDetailModal" @done="onConfirmDelete" />
        <confirmation-modal tag="confirmUserAddcancel" @done="processApprovalCancelBack" />
        <confirmation-modal tag="notificationAfterUserCancel" @done="afterTheNotificationAftercancel" />
        <confirmation-modal tag="confirmSetDefaultPassword" @done="onSetDefaultPassword" />
    </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_master_user';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:master_user');
import fieldBoxes from '@/components/form-field';
import acl from '@/rules/acl_rules';
import applicationConfirmationModal from '@/components/modals/application-confirmation-modal';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
    'application-confirmation-modal':applicationConfirmationModal,
  },
  data() {
    return {
      api_name:"master_user",
      page_acl: acl.master_user_detail,
      local_seq_id:-1,
      approval_history_id:"",
      read_only_2:false,
      read_only_3:false,
      local_company:false,
      local_company_1:false,
      local_company_2:false,
      disabled_to_save:false,
      current_user_role:"",
      cacheched_form_list:false,
      original_loaded_data:{},
      local_authority_cache:{},
      user_id:"",
      local_department_and_team:[],
    };
  },
  computed: {
    userId:{
      get(){
        return this.user_id;
      },
      set(v){
        this.user_id = v;
      }
    },
    currentUserRole:{
      get(){
        return this.current_user_role;
      },
      set(v){
        this.current_user_role = v;
      }
    },
    disabledToSave:{
      get(){
        return this.disabled_to_save;
      },
      set(v){
        this.disabled_to_save = v;
      }
    },
    readOnly2:{
      get(){
        return this.read_only_2;
      },
      set(v){
        this.read_only_2 = v;
      }
    },
    readOnly3:{
      get(){
        return this.read_only_3;
      },
      set(v){
        this.read_only_3 = v;
      }
    },
    userInChargeForApproval(){
      return this.$store.state[this.stateCurrentRow].user_in_charge_for_approval > 0 || false
    },
    disableDeleteBtn(){
      return  this.userInChargeForApproval;
    },
    disableEditMainBtn(){ //編集 (edit main)
      return false;
    },
    hideDeleteBtn(){// 削除 (delete main)
      return this.hideForApplicant || this.loadBy == 'fk_id'
    },
    hideEditMainBtn(){// 編集 (edit main)
      return this.hideForApplicant || this.loadBy == 'fk_id'
    },
    isAdminSavingApplication (){
      return this.isAdmin && this.loadBy == 'fk_id';
    },
    disableApplicationBtn(){ //申請/Application
      return this.approvalStatus != "下書中";
    },
    hideApplicationBtn(){ //申請/Application
      return this.loadBy == 'fk_id';
    },
    hideApplyRejectBtn(){ //差戻/Reject
      return this.loadBy != 'fk_id'
    },
    hideApplyConfirmationBtn(){ //確認/Confirmation
      if(this.loadBy != 'fk_id'){
        return true
      }
      return this.hideForApplicant;
    },
    hideForApplicant(){
      if(this.loadBy != 'fk_id' ){
        return false
      }
      if(typeof this.$store.state[this.stateCurrentRow]["approval_history_next_approver"] == "undefined" && this.isAdmin == true)
      {
        return false;
      }
      else
      {//                                               user is the applicant                                     and            user is not the next approver the  hide
        return this.$store.state[this.stateCurrentRow]["approval_history_applicant"] == this.userId && this.$store.state[this.stateCurrentRow]["approval_history_next_approver"] != this.userId;
      }
    },
    showFieldchangedStyle (){
      return (this.$store.state[this.stateCurrentRow]["approval_status"] == "申請中" || this.$store.state[this.stateCurrentRow]["approval_status"] == "差戻") && (this.isAdmin || this.$store.state[this.stateCurrentRow]["approval_history_next_approver"])
    },
    localSeqId:{
      get(){
        return this.local_seq_id;
      },
      set(v){
        this.local_seq_id = v;
      }
    },
    Status:{
      get(){
        if(this.local_status === false){
          return this.$store.state[this.stateCurrentEditing]["status"] || "";
        }else{
          return this.local_status;
        }
       },
      set(v){
       this.$store.state[this.stateCurrentRow]["status"] = this.local_status = v;
       this.$store.state[this.stateCurrentEditing]["status"] = this.local_status = v;
       }
    },
    Password:{
      get(){
        if(this.local_password === false){
          return this.$store.state[this.stateCurrentEditing]["password"] || "";
        }else{
          return this.local_password;
        }
       },
      set(v){
       this.$store.state[this.stateCurrentRow]["password"] = this.local_password = v;
       }
    },
    loginFailureCount:{
      get(){
        if(this.local_login_failure_count === false){
          return this.$store.state[this.stateCurrentEditing]["login_failure_count"] || "";
        }else{
          return this.local_login_failure_count;
        }
       },
      set(v){
       this.$store.state[this.stateCurrentRow]["login_failure_count"] = this.local_login_failure_count = v;
       }
    },
    approvalStatus(){
      return this.$store.state[this.stateCurrentEditing]["approval_status"] || this.$store.state[this.stateCurrentRow]["approval_status"]
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    rolesList(){
      if(utils.if_null(this.currentUserRole,"") == ""){
        this.currentUserRole = Vue.localStorage.get("userRole")
      }
      if(this.currentUserRole == "保守担当"){
        return [
          "ユーザIDオペレーション担当者",  // User ID Operations Personnel
          "管理担当者",                 // Administrator
          "管理責任者",                 // Chief administrator
          "システム管理者",              // System Administrator
          "保守担当"                    // Maintenance staff
        ]
      }else if(this.currentUserRole == "システム管理者"){
        return [
          "ユーザIDオペレーション担当者",  // User ID Operations Personnel
          "管理担当者",                 // Administrator
          "管理責任者",                 // Chief administrator
          "システム管理者"              // System Administrator
        ]
      }else{
         return [
          "ユーザIDオペレーション担当者",  // User ID Operations Personnel
          "管理担当者",                 // Administrator
          "管理責任者"                 // Chief administrator
        ]
      }


    },
    formFields() {
      if(this.cacheched_form_list != false){
        return this.cacheched_form_list
      }else{
        var r = {
          col1:[
            utils.extend(fields.user_id, {}),
            utils.extend(fields.user_shimei, {}),
            utils.extend(_.clone(fields.role), {options:this.rolesList,emit_input:true}),
            utils.extend(fields.company, {}),
            utils.extend(fields.department, {}),
            utils.extend(fields.team, {}),
            utils.extend(fields.last_login_date,  { disabled: true , read_only:true}),
            utils.extend(fields.password, {}),
            utils.extend(fields.mail_address, {}),
            utils.extend(fields.login_failure_count, { disabled: true , read_only:true}),
            utils.extend(fields.status, {}),
            utils.extend(fields.last_password_changed_date, {}),
          ],
          col2_head:[
            utils.extend(fields.authority_1, {}), // authority_1_selected
          ],
          col2:[
            utils.extend(fields.company_1, {}),
            utils.extend(_.clone(fields.role_1), {
              options:this.rolesList,
              listen_for: [
              {
                name: "main_role_update1",
                mode: "select_and_set_only"
              }
            ],
              }),
            utils.extend(fields.department_1, {}),
            utils.extend(fields.team_1, {}),
          ],
          col3_head:[
            utils.extend(fields.authority_2, {}),
          ],
          col3:[
            utils.extend(fields.company_2, {}),
            utils.extend(_.clone(fields.role_2), {
              options:this.rolesList,
              listen_for: [
              {
                name: "main_role_update2",
                mode: "select_and_set_only"
              }]
            }),
            utils.extend(fields.department_2, {}),
            utils.extend(fields.team_2, {}),
          ],
        }
        this.cacheched_form_list = r;
        return r;
      }
    },

    approvalHistoryId:{
      get(){
        return this.approval_history_id;
      },
      set(v){
        this.approval_history_id = v;
      }
    },
    loadBy(){
      return this.$route.meta.load_by;
    }
  },
  methods: {
    onPreSetDefaultPassword(){
      bus.$emit("confirmSetDefaultPassword",{
        message: "パスワードを初期化しますがよろしいでしょうか？",
        title: "",
        yes_label: "OK",
        no_label: "キャンセル",
        yes_color:"primary",
        no_color:"",
        model_height:"50"
      });
    },
    onSetDefaultPassword(mode){
      if(mode== "yes"){
        this.$store.state[this.stateCurrentEditing].password = "mizuho01"
        this.$store.state[this.stateCurrentRow].password = "mizuho01"
        this.Password = "mizuho01";
        this.Status = "1";
        this.loginFailureCount = 0;
        setTimeout(() => {
          this.onSave()
        }, 100);
      }
    },
    showColumns2and3(){
      var role = Vue.localStorage.get("userRole")
      return role == "保守担当" || role == "システム管理者" || role == "ユーザIDオペレーション担当者";
    },
    dataUpdated(obj){
      var c1 = this.$store.state[this.stateCurrentEditing].company || this.$store.state[this.stateCurrentRow].company || ""
      var c2 = this.$store.state[this.stateCurrentEditing].company_1 || this.$store.state[this.stateCurrentRow].company_1 || ""
      var c3 = this.$store.state[this.stateCurrentEditing].company_2 || this.$store.state[this.stateCurrentRow].company_2 || ""

      if(obj.field == "role" ){
        var a2 = this.$store.state[this.stateCurrentEditing].authority_1 || this.$store.state[this.stateCurrentRow].authority_1 || 0
        var a3 = this.$store.state[this.stateCurrentEditing].authority_2 || this.$store.state[this.stateCurrentRow].authority_2 || 0
        var r2 = this.$store.state[this.stateCurrentEditing].role_1 || this.$store.state[this.stateCurrentRow].role_1 || ""
        var r3 = this.$store.state[this.stateCurrentEditing].role_2 || this.$store.state[this.stateCurrentRow].role_2 || ""
        var s1 = c2.length > 0 || a2 > 0 || r2.length > 0;
        var s2 = c3.length > 0 || a3 > 0 || r3.length > 0;
        bus.$emit("main_role_update1",{ allow: [obj.val] ,disable:false , select:s1});
        bus.$emit("main_role_update2",{ allow: [obj.val] ,disable:false , select:s2});
      }else if(obj.field == "company" || obj.field == "company_1" || obj.field == "company_2"){

        if(obj.field == "company"){
          c1 = obj.val;
        }
        if(obj.field == "company_1"){
          c2 = obj.val;
        }
        if(obj.field == "company_2"){
          c3 = obj.val;
        }
        var err_id = ""
        var is_err = false;
        if(c1 == c2 && c1 != "" && c1 != null ){ //&& a2 == 1
          err_id = c1;
          is_err = true;
        }else if(c1 == c3 && c1 != "" && c1 != null){ // && a3 == 1
          err_id = c1;
          is_err = true;
        }else if(c2 == c3 && c2 != "" && c2 != null){ // && a2 == 1 && a3==1
          err_id = c2;
          is_err = true;
        }
        if(is_err == true){
          this.disabledToSave = true;
          this.$notify({
              title: '所属会社は同一会社を選択できません。',
              text: "所属会社" + err_id + " が複数の場所で選択されています。",
              type: 'error',
              duration: 10000
            });
        }else{
          this.$notify({clean:true})
          this.disabledToSave = false;
        }

      }
      // this.$store.state[this.stateCurrentRow]
    },
    afterTheNotificationAftercancel(mode){
      if(mode == "no"){
        setTimeout(()=>{
          return this.$router.push("/id_approval_history");
        },600)
        console.log("afterTheNotificationAftercancel");
      }
    },
    processApprovalCancelBack(mode){
      if(mode == "yes"){
      console.log("processApprovalCancelBack",mode)
      　 this.processApproval('cancel');
        this.local_status = false;
      }
    },
    processApprovalCancel(){
      console.log("process ApprovalCancel")
      bus.$emit("confirmUserAddcancel",{
        message: "よろしいですか？",
        title: "申請を差戻します。",
        yes_label: "差戻",
        no_label: "戻る",
        yes_color:"primary",
        no_color:"",
        model_height:"50"
      });
    },
    processApprovalApprove(){
      return this.processApproval('approve');
    },
    processApproval(approve_mode){
      var changes = {
        seq_id:this.aprovalId,
        update_time: moment(new Date()).format("YYYY/MM/DD HH:mm:ss")
      }
      this.$ajax.post('/id_approval_history/prepare_to_approve/' + this.aprovalId, {changes,approve_mode:approve_mode}, (err, result) => {
          if(err){
            this.$notify({
              title: 'データの承認に失敗しました。',
              text: err,
              type: 'error',
              duration: 10000
            });
          }else{
            bus.$emit("notificationAfterUserCancel",{
              message: "",
              title: "動作が完了しました。",
              yes_label: "",
              no_label: "OK",
              yes_color:"",
              no_color:"",
              model_height:"50"
            });
          }
        })
    },
    processFieldStyle(store_key_name,last_changed_fields){
      this.$store.state[store_key_name] = {};
      if(last_changed_fields && last_changed_fields != null && last_changed_fields.length > 0 ){
        last_changed_fields.forEach(f=>{
          if(this.showFieldchangedStyle){
            this.$store.state[store_key_name][f] = ";color:red;"
          }
        });
      }
    },
    onConfirmExecuteProcessConfirmation(){
      var dcn = this.deviceControlNumber;
      if(typeof dcn == undefined || dcn == null || dcn == false || dcn.length == 0){
        dcn  = "BY_SEQ_ID::" + this.localSeqId;
      }

      var application_obj = {
        application_mode:"user",
        ref_id:dcn,
        modal_is_read_only:true,
        seq_id:this.localSeqId,
        approval_history_id : this.approvalHistoryId || false
      };
      bus.$emit("userApplicationConfimationModal",application_obj);
    },
    onConfirmExecuteProcess(){
      var dcn = this.deviceControlNumber;
      if(typeof dcn == undefined || dcn == null || dcn == false || dcn.length == 0){
        dcn  = "BY_SEQ_ID::" + this.localSeqId;
      }
      var application_obj = {
        application_mode:"user",
        ref_id:dcn,
        // approval_status:this.approvalStatus,
        seq_id:this.localSeqId,
        approval_history_id : this.approvalHistoryId || false
      }
      bus.$emit("userApplicationConfimationModal",application_obj);
    },
    onSave(){
      var pre_defined_errors = [];
      if(this.$route.params.seq_id == "new"){
        var password = this.$store.state[this.stateCurrentEditing].password;
        if(utils.if_null(password,"")==""){
          pre_defined_errors.push(fields.password)
        }
      }
      this.commonValidateFields(this,{pre_defined_errors},(error_found)=>{
        if(error_found != false){
          return;
        }
        var user_id = this.$store.state[this.stateCurrentEditing].user_id || this.$store.state[this.stateCurrentRow].user_id;
        var password = this.$store.state[this.stateCurrentEditing].password || this.$store.state[this.stateCurrentRow].password;
        var mail_address = this.$store.state[this.stateCurrentEditing].mail_address || this.$store.state[this.stateCurrentRow].mail_address;
        this.$notify({clean:true});
        if(this.userInChargeForApproval == true && this.original_loaded_data){
          var has_error = false;
          var keys =  Object.keys(this.original_loaded_data)
          keys.forEach(k =>{
            if(typeof this.$store.state[this.stateCurrentEditing][k] != "undefined"){
              if(k == "password" || k == "status"){
                // OK, skip
              }else if(this.$store.state[this.stateCurrentEditing][k] != this.original_loaded_data[k] ){
                has_error = true;
              }
            }
          })
          if(has_error == true){
            this.$notify({title: "このユーザーは申請中の申請ルートに含まれているため編集・一括編集できません",text:"",type: "error",duration: 10000});
            return;
          }
        }
        if(user_id && user_id.length > 0 && !user_id.match(/^[\.\-0-9a-zA-Z]+$/)){
          this.$notify({title: "ユーザID　は英数字のみを使用してください。",text:"",type: "error",duration: 10000});
          return;
        }
        if(password && password.length > 0 && password.indexOf("**") < 0 && !password.match(/^[\.\-0-9a-zA-Z]+$/)){
          this.$notify({title: "パスワード　は英数字のみを使用してください。",text:"",type: "error",duration: 10000});
          return;
        }
        if(mail_address && mail_address.length > 0 && !mail_address.match(/^[\@\.\-0-9a-zA-Z]+$/)){
          this.$notify({title: "メールアドレス　は英数字のみを使用してください。",text:"",type: "error",duration: 10000});
          return;
        }
        this.read_only = false;
        this.commonSaveInfo(this,this.api_name, {} ,(err,saved_data)=>{
          this.local_authority_cache = {}
          return this.$router.push("/master_user/" + saved_data.seq_id);
        });
      });
    },
    onDeviceEmbeddedInformationAddCheckConfirm(mode){
      if(mode == "yes"){
        console.log("onDeviceEmbeddedInformationAddCheckConfirm",mode)
        this.read_only = false;
        this.$store.state[this.stateCurrentEditing]["approval_status"] = "下書中";
        this.commonSaveInfo(this,this.api_name, {from_edit_form: true },(err,saved_data)=>{
          if(err){
            // Don't need to inform error here, because the error is alrady informed at commonSaveInfo
            // this.$notify({
            //   title: "Failed to save the data",
            //   text:err,
            //   type: "error",
            //   duration: 10000
            // });
          }else{
            if(saved_data && typeof this.localSeqId  != "undefined"){
              if(this.$store.state[this.stateCurrentRow].seq_id ==Number.MAX_SAFE_INTEGER ){
                if(typeof saved_data.seq_id != "undefined" && saved_data.seq_id != Number.MAX_SAFE_INTEGER ){
                  this.localSeqId  = saved_data.seq_id;
                }
              }else if(this.$store.state[this.stateCurrentRow].seq_id  <  this.localSeqId &&  this.localSeqId==Number.MAX_SAFE_INTEGER ){
                this.localSeqId =this.$store.state[this.stateCurrentRow].seq_id
              }
            }

            bus.$emit("notificationAfterSave",{
              message: "",
              title: "登録情報を下書保存しました。",
              yes_label: "",
              no_label: "OK",
              yes_color:"",
              no_color:"",
              model_height:"50"
            });
          }
        });
      }
    },
    afterTheNotificationAfterSave(mode){
      if(mode == "no" || mode == "yes"){
        return this.$router.push("/master_user/" + this.localSeqId );
      }
    },
    // onSave(){
    //   this.read_only = false;
    //   this.commonSaveInfo(this,this.api_name, {} );
    // },
    btnCancel() {
      this.commonValidateFieldsClear(this,()=>{})
      this.cancelCurrentSelection(true);
    },
    onEdit(){
      this.$notify({clean:true});
      if(this.userId == this.$store.state[this.stateCurrentRow]["user_id"]){
        if(Vue.localStorage.get("userRole") == "ユーザIDオペレーション担当者" ){
          this.$notify({
            title: "自分のIDは編集できません。",
            type: 'error',
            duration: 10000
          });
          return;
        }
      }
      this.$ajax.post('/' + this.api_name + '/check_can_edit/' + this.localSeqId, {}, (err, result) => {
        if(err){
          this.$notify({
            title: err.replace("::",""),
            type: 'error',
            duration: 10000
          });
        }else{

          //TODO: Here need to change the #342
          var temp_fields = this.installedFieldList;
          let allowed_companies = [];
            this.local_department_and_team.forEach((item)=>{
              if(item.company){
                allowed_companies.push({
                  company: item.company,
                  department: item.department,
                  team: item.team,
                  user_company_seq: item.user_company_seq,
                });
              }
            })
            if(this.isMultiCompanyAdmin == false){
              let base_control_cmd = "disable"
              let a0_control_cmd = "disable"
              let a1_control_cmd = "disable"
              let a2_control_cmd = "disable"
              const company = this.$store.state[this.stateCurrentRow]["company"]
              const department = this.$store.state[this.stateCurrentRow]["department"]
              const company_1 = this.$store.state[this.stateCurrentRow]["company_1"]
              const department_1 = this.$store.state[this.stateCurrentRow]["department_1"]
              const authority_1 = this.$store.state[this.stateCurrentRow]["authority_1"]
              const company_2 = this.$store.state[this.stateCurrentRow]["company_2"]
              const department_2 = this.$store.state[this.stateCurrentRow]["department_2"]
              const authority_2 = this.$store.state[this.stateCurrentRow]["authority_2"]
              const allow_0 = _.find(allowed_companies,(a) =>{ return a.company == company &&  a.department == department}) || false
              const allow_1 = _.find(allowed_companies,(a) =>{ return a.company == company_1 &&  a.department == department_1}) || department_1 == null || department_1 == '' || false
              const allow_2 = _.find(allowed_companies,(a) =>{ return a.company == company_2 &&  a.department == department_2}) || department_2 == null || department_2 == '' || false

              var operator_main_company = _.find(allowed_companies,(a) =>{ return a.user_company_seq == 0}) || false
              if(operator_main_company){
                operator_main_company = operator_main_company.company
              }
              var operator_other_companies = []
              if(operator_main_company != false){
                allowed_companies.forEach((item)=>{
                  if(item.company != operator_main_company && operator_other_companies.indexOf(item.company) == -1){
                    operator_other_companies.push(item.company)
                  }
                })
              }
              if(allow_0){
                base_control_cmd = "enable"
                a0_control_cmd = "enable"
              }
              if (allow_1){
                a1_control_cmd = "enable"
              }
              if (allow_2){
                a2_control_cmd = "enable"
              }

              // base_control_cmd
              temp_fields.user_id.page_controller_msg({cmd:base_control_cmd})
              temp_fields.user_shimei.page_controller_msg({cmd:base_control_cmd})
              temp_fields.status.page_controller_msg({cmd:base_control_cmd})
              temp_fields.mail_address.page_controller_msg({cmd:base_control_cmd})

              // a0_control_cmd
              temp_fields.team.page_controller_msg({cmd:a0_control_cmd})
              temp_fields.department.page_controller_msg({cmd:a0_control_cmd})
              temp_fields.company.page_controller_msg({cmd:a0_control_cmd})
              temp_fields.role.page_controller_msg({cmd:a0_control_cmd})

              // a1_control_cmd
              temp_fields.team_1.page_controller_msg({cmd:a1_control_cmd})
              temp_fields.department_1.page_controller_msg({cmd:a1_control_cmd})
              temp_fields.company_1.page_controller_msg({cmd:a1_control_cmd})
              temp_fields.role_1.page_controller_msg({cmd:a1_control_cmd})
              temp_fields.authority_1.page_controller_msg({cmd:a1_control_cmd})

              // a2_control_cmd
              temp_fields.team_2.page_controller_msg({cmd:a2_control_cmd})
              temp_fields.department_2.page_controller_msg({cmd:a2_control_cmd})
              temp_fields.company_2.page_controller_msg({cmd:a2_control_cmd})
              temp_fields.role_2.page_controller_msg({cmd:a2_control_cmd})
              temp_fields.authority_2.page_controller_msg({cmd:a2_control_cmd})
            }

          this.commonOnEdit();
        }
      })
    },
    backToList(){
      var user_back_to_list = window.sessionStorage.getItem("user_back_to_list")
      if(this.loadBy == "fk_id"){
        return this.$router.push({ name: "page_0050_id_approval_history", params: {} });
      }else if((user_back_to_list||"").indexOf("/")==0){
        return this.$router.push(user_back_to_list);
      }else{
        return this.$router.push({ name: "page_0041_master_user", params: {} });
      }
    },
    onConfirmDelete(mode){
      if(mode == "yes"){
        this.commonDelete(this);
      }
    },
    onDelete(){
      this.$notify({clean:true});
      if(this.userId == this.$store.state[this.stateCurrentRow]["user_id"]){
        this.$notify({
          title: "自分のIDは削除できません。",
          type: 'error',
          duration: 10000
        });
        return;
      }
      bus.$emit("deleteMasterUserDetailModal",{
        title: "削除",
        message: "ユーザの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color:"danger",
        no_color:"info",
        model_height:"50"
      });
    },
    /**
     * This is a special structure to manipulate th company, deparment and team at master user page.
     * Instead of let the control at the fields, it controls the select-box4 from here.
     */
    prepareCompanySelection(companies, department_and_team, company_field, department_field,team_field,company_field_name,department_field_name){
          var selected_company = false;
          var selected_department = false
          // if(this.userInChargeForApproval){
          //   department_field.page_controller_msg({cmd:"disable"})
          //   team_field.page_controller_msg({cmd:"disable"})
          //   company_field.page_controller_msg({cmd:"disable"})
          //   return;
          // }
          company_field.page_controller_setup({
            on_select:(_selected_company)=>{
              selected_company = _selected_company;
              if(selected_company==""){
                department_field.page_controller_msg({cmd:"disable"})
                team_field.page_controller_msg({cmd:"disable"})
              }else{
                var departments =  _.uniq(_.map(_.filter(department_and_team||[],(d)=>{return d.company == selected_company})||[],"department")||[]);
                departments.unshift("")
                department_field.page_controller_msg({cmd:"enable"})
                department_field.page_controller_msg({cmd:"set_value",val:""})
                team_field.page_controller_msg({cmd:"set_value",val:""})
                team_field.page_controller_msg({cmd:"disable"})
                department_field.page_controller_msg({cmd:"set_options",options:departments, reset:true})
              }
            }
          })
          department_field.page_controller_setup({
            on_select:(_selected_department)=>{
              selected_department = _selected_department;
              if(selected_department == ""){
                team_field.page_controller_msg({cmd:"disable"})
                team_field.page_controller_msg({cmd:"set_value",val:""})
              }else{
                var teams =  _.uniq(_.map(_.filter(department_and_team||[],(d)=>{return d.company == selected_company && d.department == selected_department})||[],"team")||[]);
                teams.unshift("");
                team_field.page_controller_msg({cmd:"enable"})
                team_field.page_controller_msg({cmd:"set_value",val:""})
                team_field.page_controller_msg({cmd:"set_options",options:teams, reset:true})
              }
            }
          })
          company_field.page_controller_msg({cmd:"set_options",options: _.clone(companies)})
          company_field.page_controller_msg({cmd:"enable"})
          department_field.page_controller_msg({cmd:"disable"})
          team_field.page_controller_msg({cmd:"disable"})
          setTimeout(() => {
            department_field.page_controller_msg({cmd:"enable_if_data"})
            team_field.page_controller_msg({cmd:"enable_if_data"})
            selected_company = this.$store.state[this.stateCurrentRow][company_field.id]
            selected_department = this.$store.state[this.stateCurrentRow][department_field.id]
            if(selected_company && selected_company.length > 0){
              department_field.page_controller_msg({ cmd: "enable" });
              var departments =  _.uniq(_.map(_.filter(department_and_team||[],(d)=>{return d.company == selected_company})||[],"department")||[]);
              department_field.page_controller_msg({cmd:"set_options",options:departments, reset:false})
              if(selected_department && selected_department.length > 0){
                var teams =  _.uniq(_.map(_.filter(department_and_team||[],(d)=>{return d.company == selected_company &&  d.department == selected_department})||[],"team")||[]);
                team_field.page_controller_msg({cmd:"set_options",options:teams, reset:false})
              }
            }
          }, 500);
    }
  },
  mounted() {
    this.userId = Vue.localStorage.get("userID") || "";
    // Control the special fields
    if(true){
      var temp_fields = this.installedFieldList;

      // Load the companies
      this.$ajax.post_cached_queued('/master_company/list_company_name_for_user_control' , {}, (err, _companies) => {
        if(err){
          this.$notify({
              title: '所属会社　が読み込めませんでした。',
              text: err,
              type: 'error',
              duration: 10000
            });
          return ;
        }
        var companies = [""]
        _companies.forEach(c=>{
          companies.push(c.val)
        })
        // Load the departments and teams
        this.$ajax.post_cached_queued('/master_belongs/list_department_for_user_control' , {}, (err, department_and_team) => {
          if(err){
            this.$notify({
                title: '部署・チームのデータが読み込めませんでした。',
                text: err,
                type: 'error',
                duration: 10000
              });
            return ;
          }
          this.local_department_and_team = department_and_team;
          this.prepareCompanySelection(_.clone(companies), _.clone(department_and_team), temp_fields.company, temp_fields.department,temp_fields.team,"company","department")
          this.prepareCompanySelection(_.clone(companies), _.clone(department_and_team), temp_fields.company_1, temp_fields.department_1,temp_fields.team_1,"company_1","department_1")
          this.prepareCompanySelection(_.clone(companies), _.clone(department_and_team), temp_fields.company_2, temp_fields.department_2,temp_fields.team_2,"company_2","department_2")
        })
      })
    }



    this.local_authority_cache = {}
    this.currentUserRole = Vue.localStorage.get("userRole")
    bus.$off("authority_1_selected").$on("authority_1_selected",(new_value)=>{
      this.readOnly2 = new_value == 0;
      var disable_fields = ["company_1","role_1","department_1","team_1"];
      disable_fields.forEach(f =>{
        if(this.readOnly2 == true){
          this.local_authority_cache[f] = this.$store.state[this.stateCurrentEditing][f] || this.$store.state[this.stateCurrentRow][f] || "";
          this.$store.state[this.stateCurrentEditing][f] = ""
          this.$store.state[this.stateCurrentRow][f] = ""
          }else{
            if(this.local_authority_cache[f]){
              this.$store.state[this.stateCurrentEditing][f] = this.local_authority_cache[f]
              this.$store.state[this.stateCurrentRow][f] = this.local_authority_cache[f]
              delete this.local_authority_cache[f];
            }
          }
      })
    })
    bus.$off("authority_2_selected").$on("authority_2_selected",(new_value)=>{
      this.readOnly3 = new_value == 0;
      var disable_fields = ["company_2","role_2","department_2","team_2"];
      disable_fields.forEach(f =>{
        if(this.readOnly3 == true){
          this.local_authority_cache[f] = this.$store.state[this.stateCurrentEditing][f] || this.$store.state[this.stateCurrentRow][f] || "";
          this.$store.state[this.stateCurrentEditing][f] = ""
          this.$store.state[this.stateCurrentRow][f] = ""
          }else{
            if(this.local_authority_cache[f]){
              this.$store.state[this.stateCurrentEditing][f] = this.local_authority_cache[f]
              this.$store.state[this.stateCurrentRow][f] = this.local_authority_cache[f]
              delete this.local_authority_cache[f];
            }
          }
      })
    })

    if(this.loadBy == "fk_id"){
        this.is_new = false;
        this.localSeqId = this.$route.params.fk_id;
        this.aprovalId = this.$route.params.approval_id;
        this.$ajax.post('/' + this.api_name + '/get/' + this.localSeqId, {fk_id: this.localSeqId}, (err, result) => {
          if(err){
            this.$notify({
              title: 'データの読み込みが出来ませんでした。',
              text: err,
              type: 'error',
              duration: 10000
            });
          }
          this.localSeqId = result.data.seq_id;
          this.$store.state[this.stateCurrentRow] = result.data;
          if(typeof this.$store.state[this.stateCurrentRow].approval_history_id == "number"){
            this.approvalHistoryId = this.$store.state[this.stateCurrentRow].approval_history_id
          }

          this.commonSetStyleForChangedFields(result.data);
          // bus.$emit("reloadSubTableDeviceEmbeddedInformation",{fk_id:this.localSeqId});
          mdebug("LOAD DATA",{err, result});
        })
    }else{
      this.commonLoadRecord({},(err,result)=>{
        if(this.$route.params.seq_id == "new"){
            this.Status = 1;
            this.Password = "mizuho01";
            setTimeout(()=>{
              this.$store.state[this.stateCurrentEditing].password = "mizuho01"
              this.$store.state[this.stateCurrentRow].password = "mizuho01"
              this.Password = "mizuho01";
            },300)

            bus.$emit("main_role_update1",{ allow: [""] ,disable:true,select:true});
            bus.$emit("main_role_update2",{ allow: [""] ,disable:true,select:true});
        }else{
          this.original_loaded_data = result.data;
          console.log('TEST DEBUG 210707 (799 at page_0041_master_user_detail.vue)[23:51]: ', JSON.stringify(  this.original_loaded_data,null,4));
          this.$store.state[this.stateCurrentRow].password = "**"
          if(result && result.data && result.data.role && result.data.role.length > 0){
            bus.$emit("main_role_update1",{ allow: [result.data.role] ,disable:false,select:false}, );
            bus.$emit("main_role_update2",{ allow: [result.data.role] ,disable:false,select:false});
          }else{
            bus.$emit("main_role_update1",{ allow: [""] ,disable:true,select:true});
            bus.$emit("main_role_update2",{ allow: [""] ,disable:true,select:true});
          }
        }
        this.localSeqId = this.$route.params.seq_id;
        if(typeof this.$store.state[this.stateCurrentRow].approval_history_id == "number"){
          this.approvalHistoryId = this.$store.state[this.stateCurrentRow].approval_history_id
        }
        this.readOnly2 = this.$store.state[this.stateCurrentRow].authority_1 != 1;
        this.readOnly3 = this.$store.state[this.stateCurrentRow].authority_2 != 1;

        this.commonEditDeleteCmdHandler(this)
        console.log("CMD IN",this.$route.params.cmd)
      });
      console.log("CMD",this.$route.params.cmd)
    }
  },
  beforeDestroy() {
  },
  beforeMount() {
    this.cacheched_form_list = false;
  }
};

</script>
<style scoped>

input:focus::-webkit-input-placeholder {
  color: transparent;
}
.tabs {
  margin-top: 50px;
  padding-bottom: 40px;
  background-color: #fff;
  position:relative;
			left:50px;
  /*width:400px;*/

  }

/*タブのスタイル*/
.tab_item {
  width:150px;
  height: 50px;
  border-bottom: 3px solid #979797;
  background-color: #5b9bd5;
  line-height: 50px;
  font-size: 16px;
  text-align: center;
  color: #ffffff;
  display: block;

  text-align: center;

  transition: all 0.2s ease;
  border-radius: 0.75em 0.75em 0px 0px;
  display: inline-block;

}
.tab_item:hover {
  opacity: 0.75;
}

/*ラジオボタンを全て消す*/
input[name="tab_item"] {
  display: none;
}

/*タブ切り替えの中身のスタイル*/
.tab_content {
  display: none;
  padding: 40px 40px 0;
  clear: both;
  overflow: hidden;
}


/*選択されているタブのコンテンツのみを表示*/
#all:checked ~ #all_content,
#programming:checked ~ #programming_content,
#design:checked ~ #design_content {
  display: block;
}

/*選択されているタブのスタイルを変える*/
.tabs input:checked + .tab_item {
  background-color: #d9d9d9;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// page_0041_master_user_detail.vue?1abd8c20